export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: "全部",
    },
    {
      value: 0,
      name: "Selling",
      text: "販售中",
    },
    {
      value: 1,
      name: "StopSale",
      text: "已下架",
    },
  ];
}
